import EnquiryTypesConfig from './EnquiryTypesConfig';
export default EnquiryTypesConfig;
